<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { ref, onMounted, onBeforeUnmount, watch, computed } from 'vue'
import moment from 'moment'

const props = defineProps({
  modelValue: {
    type: Array as () => any[],
    default: () => []
  },
  placeholder: {
    type: String,
    default: 'Chọn ngày'
  },
  options: {
    type: Object as () => any,
    default: null
  },
  readOnly: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const readOnly = computed(() => props.readOnly)
const dateRangeValue = ref([...props.modelValue])
const openPanel = ref(false)
const containerRef = ref<HTMLElement | null>(null)
const minDate = computed(() => {
  return props.options?.minDate ? moment(props.options.minDate).toDate() : undefined
})
const maxDate = computed(() => {
  return props.options?.maxDate ? moment(props.options.maxDate).toDate() : undefined
})
const showTime = computed(() => {
  return !!props.options?.showTime
})

// Đồng bộ khi props.modelValue thay đổi từ bên ngoài
watch(() => props.modelValue, (newVal) => {
  dateRangeValue.value = [...newVal]
})

// Đồng bộ ngược khi người dùng chọn/deselect hoặc clear
watch(dateRangeValue, (newVal) => {
  if (JSON.stringify(newVal) !== JSON.stringify(props.modelValue)) {
    emit('update:modelValue', newVal)
  }
}, { flush: 'sync' })

// Toggle giá trị (nếu cần dùng cho multi-select)
const toggleValue = (val: any) => {
  const index = dateRangeValue.value.indexOf(val)
  if (index >= 0) {
    dateRangeValue.value.splice(index, 1)
  } else {
    dateRangeValue.value.push(val)
  }
}

// Đóng dropdown nếu click ra ngoài
const handleClickOutside = (event: MouseEvent) => {
  if (containerRef.value && !containerRef.value.contains(event.target as Node)) {
    openPanel.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})
onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<template>
  <div class="filter-date-range" ref="containerRef">
    <DatePicker
      v-model="dateRangeValue"
      selectionMode="range"
      :manualInput="false"
      :show-time="showTime"
      :min-date="minDate"
      :max-date="maxDate"
      :placeholder="props.placeholder"
      :readonly="readOnly"
    />
    <span v-if="dateRangeValue.length > 0" class="clear-all" @click="dateRangeValue = []">
      <Icon icon="material-symbols:close" />
    </span>
  </div>
</template>
